class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // Danis Drip: „Dazulegen“ bei den Vorschlägen im Warenkorb-Fenster
    this.notification.addEventListener('click', (evt) => {
      const addButton = evt.target.closest('[data-dd-add]');
      if (!addButton) return;
      evt.preventDefault();
      this.addUpsellItem(addButton);
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target) return;
      if (section.id === 'dd-cart-upsell') {
        this.renderUpsell(target, parsedState.sections ? parsedState.sections[section.id] : null);
        return;
      }
      target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'dd-cart-upsell',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  // Danis Drip: zeigt die Vorschläge zum gerade hinzugefügten Artikel
  renderUpsell(target, html) {
    try {
      target.innerHTML = html ? this.getSectionInnerHTML(html) : '';
    } catch (error) {
      target.innerHTML = '';
    }
    const blocks = target.querySelectorAll('[data-dd-upsell-key]');
    let shown = false;
    blocks.forEach((block) => {
      const match = block.dataset.ddUpsellKey === this.cartItemKey;
      block.hidden = !match;
      if (match) shown = true;
    });
    if (!shown && blocks.length) blocks[0].hidden = false;
  }

  // Danis Drip: legt einen Vorschlag direkt in den Warenkorb, ohne das Fenster zu schließen
  addUpsellItem(button) {
    if (button.disabled || button.classList.contains('is-added')) return;
    const label = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const sections = ['cart-icon-bubble', 'cart-notification-button'];

    fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.ddAdd), quantity: 1, properties: { _dd_upsell: 'warenkorb-fenster' } }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || 'cart');
        if (response.sections) {
          sections.forEach((id) => {
            const element = document.getElementById(id);
            if (element && response.sections[id]) element.innerHTML = this.getSectionInnerHTML(response.sections[id]);
          });
        }
        button.textContent = button.dataset.ddDone || '✓';
        button.classList.add('is-added');
        // löst die vorhandene Aktualisierung des Versandbalkens aus
        this.notification.classList.toggle('dd-upsell-updated');
      })
      .catch(() => {
        button.disabled = false;
        button.textContent = label;
      })
      .finally(() => button.classList.remove('is-loading'));
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);